import {RemoteData} from "../timing_lite/store";

export function isEmpty(value: any): boolean {
    return value === undefined || value === null || value === ""
}

export let logger: (message?: any, ...optionalParams: any[]) => void;

const REMOTE_DATA: RemoteData = window.json_context;


if (REMOTE_DATA.debug) {
    logger = console.log;
} else {
    logger = function (message?: any, ...optionalParams: any[]) {

    }
}


export interface Map<K, V> {
    [K: string]: V;
}

// interface MapConstructor {
//     // fromJSON(json: string): Map<any, any>;
//     // fromJSON<K, V>(json: string): Map<K, V>;
//
// }